//This helper function is used to generate columns definitions based on time periods comparison
import {
	TIME_PERIOD_ENUMS,
	WMT_WEEK_TO_DATE,
	WTD,
	CUSTOM,
} from '../../constants/constant';

export const generateColumnDefs = (
	timePeriods,
	sourceColDefs,
	weekFilter,
	timePeriodOptions,
	selectedFilter
) => {
	const newColumnDefs = [...sourceColDefs];

	// Creating a new copy of timePeriods array
	let timePeriodsArray = [];

	if (timePeriods) {
		timePeriodsArray = [...timePeriods];
	}

	// Fetch the main time filter, Map it to ENUM value
	const mainFilter = mapWeekFilterToEnum(weekFilter, timePeriodOptions);

	// Reverse the TimePeriods array
	timePeriodsArray = timePeriodsArray.reverse();

	// Add it to our timePeriodsArray before iteration
	timePeriodsArray?.push(mainFilter);

	// Initialize empty array for Net Sales New Children
	const netSales_newChildren = [];
	const units_newChildren = [];
	const aur_newChildren = [];

	// In Omni we have to generate 14 sets of columns in each period
	// In Store 26 sets of columns
	// In eCommerce 6 sets of columns

	// Generate columns over time periods
	timePeriodsArray.forEach((item) => {
		netSales_newChildren.unshift(
			{
				field: `${item.value}` + '_ty_ns',
				headerName: `${item.shortLabel}`,
				cellClass: 'currencyFormat',
			},
			{
				field: `${item.value}` + '_absoluteYoY_ns',
				headerName: `${item.shortLabel}` + ' YoY $ Chg',
				cellClass: 'currencyFormat',
			},
			{
				field: `${item.value}` + '_percentYoY_ns',
				headerName: `${item.shortLabel}` + ' YoY % Chg',
				cellClass: 'percentFormat',
			}
		);

		units_newChildren?.unshift(
			{
				field: `${item.value}` + '_ty_units',
				headerName: `${item.shortLabel}`,
				cellClass: 'unitsFormat',
			},
			{
				field: `${item.value}` + '_absoluteYoY_units',
				headerName: `${item.shortLabel}` + ' YoY Chg',
				cellClass: 'unitsFormat',
			},
			{
				field: `${item.value}` + '_percentYoY_units',
				headerName: `${item.shortLabel}` + ' YoY % Chg',
				cellClass: 'percentFormat',
			}
		);

		aur_newChildren.unshift(
			{
				field: `${item.value}` + '_ty_aur',
				headerName: `${item.shortLabel}`,
				cellClass: 'currencyFormat',
			},
			{
				field: `${item.value}` + '_absoluteYoY_aur',
				headerName: `${item.shortLabel}` + ' YoY $ Chg',
				cellClass: 'currencyFormat',
			},
			{
				field: `${item.value}` + '_percentYoY_aur',
				headerName: `${item.shortLabel}` + ' YoY % Chg',
				cellClass: 'percentFormat',
			}
		);
	});

	// Accessing & Updating Net Sales Children Columns
	newColumnDefs[1].children[0].children = netSales_newChildren;

	// Accessing & Updating Units Children Columns
	newColumnDefs[1].children[1].children = units_newChildren;

	// Accessing & Updating AUR Children Columns
	newColumnDefs[1].children[2].children = aur_newChildren;

	if (selectedFilter == 'Omni' || selectedFilter == 'Store') {
		// Initialize empty array for Fulfillment New Children
		const buyInStore_newChildren = [];
		const pickUp_newChildren = [];
		const delivery_newChildren = [];
		const shipFromStore_newChildren = [];

		// Generate columns over time periods
		timePeriodsArray.forEach((item) => {
			buyInStore_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_bis',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_bis',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_bis',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			pickUp_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_pickup',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_pickup',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_pickup',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			delivery_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_delivery',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_delivery',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_delivery',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			shipFromStore_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_sfs',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_sfs',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_sfs',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);
		});

		// Accessing & Updating Buy In Store Children Columns
		newColumnDefs[2].children[0].children = buyInStore_newChildren;
		// Accessing & Updating Pickup Children Columns
		newColumnDefs[2].children[1].children = pickUp_newChildren;
		// Accessing & Updating Delivery Children Columns
		newColumnDefs[2].children[2].children = delivery_newChildren;
		// Accessing & Updating Ship from Store Children Columns
		newColumnDefs[2].children[3].children = shipFromStore_newChildren;
	}

	if (selectedFilter == 'Omni' || selectedFilter == 'eCom') {
		// Initialize empty array for Fulfillment New Children
		const shipToHome_newChildren = [];
		const shipToStore_newChildren = [];

		timePeriodsArray.forEach((item) => {
			shipToHome_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_s2h',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_s2h',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_s2h',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			shipToStore_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_s2s',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_s2s',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_s2s',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);
		});

		//Accessing & Updating Ship to Home Children Columns
		if (selectedFilter == 'Omni') {
			newColumnDefs[2].children[4].children = shipToHome_newChildren;
			newColumnDefs[2].children[5].children = shipToStore_newChildren;
		} else {
			newColumnDefs[2].children[0].children = shipToHome_newChildren;
			newColumnDefs[2].children[1].children = shipToStore_newChildren;
		}
	}

	if (selectedFilter == 'Store') {
		// Initialize empty array for Inventory New Children
		const storeOnHand_newChildren = [];
		const storeOnOrder_newChildren = [];
		const storeDCtoStore_newChildren = [];
		const storeInWhse_newChildren = [];
		const totalStoreInventory_newChildren = [];
		timePeriodsArray.forEach((item) => {
			storeOnHand_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_soh',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_soh',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_soh',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			storeOnOrder_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_soo',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_soo',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_soo',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			storeDCtoStore_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_sdts',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_sdts',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_sdts',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			storeInWhse_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_siw',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_siw',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_siw',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			totalStoreInventory_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_tsi',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_tsi',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_tsi',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);
		});

		//Accessing & Updating Inventory Children Columns
		if (newColumnDefs.length > 3 && newColumnDefs[3].children.length > 4) {
			newColumnDefs[3].children[0].children = storeOnHand_newChildren;
			newColumnDefs[3].children[1].children = storeOnOrder_newChildren;
			newColumnDefs[3].children[2].children = storeDCtoStore_newChildren;
			newColumnDefs[3].children[3].children = storeInWhse_newChildren;
			newColumnDefs[3].children[4].children = totalStoreInventory_newChildren;
		}

		// Creating new empty arrays for Replenishment
		const inStockPercent_newChildren = [];

		timePeriodsArray.forEach((item) => {
			inStockPercent_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_sisp',
					headerName: `${item.shortLabel}`,
					cellClass: 'floatFormat',
				},
				// {
				// 	field: `${item.value}` + '_absoluteYoY_sisp',
				// 	headerName: `${item.shortLabel}` + ' YoY $ Chg',
				// },
				{
					field: `${item.value}` + '_percentYoY_sisp',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);
		});
		if (newColumnDefs.length > 4 && newColumnDefs[4].children.length) {
			//Accessing & Updating Replenishment Children Columns
			newColumnDefs[4].children[0].children = inStockPercent_newChildren;
		}

		// Creating new empty arrays for Points of Distribution
		const traitedStoreCount_newChildren = [];
		const traitedItemCount_newChildren = [];
		const validStoreCount_newChildren = [];

		timePeriodsArray.forEach((item) => {
			traitedStoreCount_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_traitedStore',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_traitedStore',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_traitedStore',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			traitedItemCount_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_traitedItem',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_traitedItem',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_traitedItem',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			validStoreCount_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_validStore',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_validStore',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_validStore',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);
		});

		if (newColumnDefs.length > 5 && newColumnDefs[5].children.length > 2) {
			//Accessing & Updating Replenishment Children Columns
			newColumnDefs[5].children[0].children = traitedStoreCount_newChildren;
			newColumnDefs[5].children[1].children = traitedItemCount_newChildren;
			newColumnDefs[5].children[2].children = validStoreCount_newChildren;
		}

		// Creating new empty arrays for Velocity
		const dollarSW_newChildren = [];
		const unitSW_newChildren = [];

		timePeriodsArray.forEach((item) => {
			dollarSW_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_dollarSW',
					headerName: `${item.shortLabel}`,
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_dollarSW',
					headerName: `${item.shortLabel}` + ' YoY $ Chg',
					cellClass: 'currencyFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_dollarSW',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);

			unitSW_newChildren.unshift(
				{
					field: `${item.value}` + '_ty_unitSW',
					headerName: `${item.shortLabel}`,
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_absoluteYoY_unitSW',
					headerName: `${item.shortLabel}` + ' YoY Chg',
					cellClass: 'unitsFormat',
				},
				{
					field: `${item.value}` + '_percentYoY_unitSW',
					headerName: `${item.shortLabel}` + ' YoY % Chg',
					cellClass: 'percentFormat',
				}
			);
		});

		if (newColumnDefs.length > 6 && newColumnDefs[6].children.length > 1) {
			//Accessing & Updating Velocity Children Columns
			newColumnDefs[6].children[0].children = dollarSW_newChildren;
			newColumnDefs[6].children[1].children = unitSW_newChildren;
		}

		// Creating new empty arrays for OPD
		const totalOrderQuantity_newChildren = [];
		const preSubQuantity_newChildren = [];
		const subQuantity_newChildren = [];
		const nilPick_newChildren = [];
		const firstTimePick_newChildren = [];
		const nilPickRate_newChildren = [];
		const preSubRate_newChildren = [];
		const postSubRate_newChildren = [];

		timePeriodsArray.forEach((item) => {
			totalOrderQuantity_newChildren.unshift({
				field: `${item.value}` + '_ty_toq',
				headerName: `${item.shortLabel}`,
				cellClass: 'unitsFormat',
			});

			preSubQuantity_newChildren.unshift({
				field: `${item.value}` + '_ty_presubQty',
				headerName: `${item.shortLabel}`,
				cellClass: 'unitsFormat',
			});

			subQuantity_newChildren.unshift({
				field: `${item.value}` + '_ty_subQty',
				headerName: `${item.shortLabel}`,
				cellClass: 'unitsFormat',
			});

			nilPick_newChildren.unshift({
				field: `${item.value}` + '_ty_nilPicQty',
				headerName: `${item.shortLabel}`,
				cellClass: 'unitsFormat',
			});

			firstTimePick_newChildren.unshift({
				field: `${item.value}` + '_ty_ftpr',
				headerName: `${item.shortLabel}`,
				cellClass: 'percentFormat',
			});

			nilPickRate_newChildren.unshift({
				field: `${item.value}` + '_ty_nilPics',
				headerName: `${item.shortLabel}`,
				cellClass: 'percentFormat',
			});

			preSubRate_newChildren.unshift({
				field: `${item.value}` + '_ty_presubRate',
				headerName: `${item.shortLabel}`,
				cellClass: 'percentFormat',
			});

			postSubRate_newChildren.unshift({
				field: `${item.value}` + '_ty_postsubRate',
				headerName: `${item.shortLabel}`,
				cellClass: 'percentFormat',
			});
		});

		if (newColumnDefs.length > 7 && newColumnDefs[7].children.length > 7) {
			//Accessing & Updating OPD Children Columns
			newColumnDefs[7].children[0].children = totalOrderQuantity_newChildren;
			newColumnDefs[7].children[1].children = preSubQuantity_newChildren;
			newColumnDefs[7].children[2].children = subQuantity_newChildren;
			newColumnDefs[7].children[3].children = nilPick_newChildren;
			newColumnDefs[7].children[4].children = firstTimePick_newChildren;
			newColumnDefs[7].children[5].children = nilPickRate_newChildren;
			newColumnDefs[7].children[6].children = preSubRate_newChildren;
			newColumnDefs[7].children[7].children = postSubRate_newChildren;
		}
	}

	// Add sort on first column metrics
	if (
		newColumnDefs?.length > 1 &&
		newColumnDefs[1]?.children?.length &&
		newColumnDefs[1]?.children[0]?.children?.length
	) {
		newColumnDefs[1].children[0].children[0].sort = 'desc';
	}
	// Return modified columns
	return newColumnDefs;
};

export const mapWeekFilterToEnum = (weekFilterValue, timePeriodOptions) => {
	let result = null;
	switch (weekFilterValue) {
		case -1:
			result = {
				title: CUSTOM,
				value: TIME_PERIOD_ENUMS.CUSTOM,
				label: CUSTOM,
				shortLabel: CUSTOM,
			};
			break;
		case 0:
			result = {
				title: WMT_WEEK_TO_DATE,
				value: TIME_PERIOD_ENUMS.WTD,
				label: WMT_WEEK_TO_DATE,
				shortLabel: WTD,
			};
			break;
		case 1:
			result = timePeriodOptions[0];
			break;
		case 4:
			result = timePeriodOptions[1];
			break;
		case 13:
			result = timePeriodOptions[2];
			break;
		case 26:
			result = timePeriodOptions[3];
			break;
		case 52:
			result = timePeriodOptions[4];
			break;
		default:
			result = {
				title: WMT_WEEK_TO_DATE,
				value: TIME_PERIOD_ENUMS.WTD,
				label: WMT_WEEK_TO_DATE,
				shortLabel: WTD,
			};
	}
	return result;
};
n